export const GAME_WIDTH = 390;
export const GAME_HEIGHT = 844;
export const GRAVITY_Y = 980;
export const GAME_OVER_HIT_LOOP_OVERLAP_MS = 200;
